// @flow
import React from 'react'
import Crumb from './crumb'
import CurrentCrumb from './current-crumb'

type CrumbType = {
  linkUrl: string,
  linkText: string,
  className?: string
}

type BreadCrumbsProps = {
  current: string,
  crumbs: Array<CrumbType>
}

const renderCrumbs = crumbs =>
  crumbs.map((crumb, i) => <Crumb crumb={crumb} key={i} />)

const Breadcrumbs = (props: BreadCrumbsProps) => {
  const { crumbs, current } = props
  return (
    <ul className='breadcrumbs'>
      {crumbs && renderCrumbs(crumbs)}
      <CurrentCrumb current={current} />
    </ul>
  )
}

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/ui/lists/breadcrumbs.js